export enum ContentStatus {
  Uploading = "UPLOADING",
  Ready = "READY",
  Queued = "QUEUED",
  Processing = "PROCESSING",
  Error = "ERROR",
}
